import {
  FIELDNAMES,
  KNOWN_FORM_VALUES,
} from '@/components/molecules/Form/utils/constants'
import { toast } from 'react-toastify'

const { DONATION_PRIVACY, DONATION_TERMS, DONATION_AMOUNT } = FIELDNAMES
const { TRUE } = KNOWN_FORM_VALUES

export class ValidationError extends Error {
  constructor(field, code, message) {
    super(message)
    this.name = 'ValidationError'
    this.field = field
    this.code = code
  }
}

class PaymentValidator {
  isPrivacyAccepted(privacyValue) {
    return (
      privacyValue === true ||
      privacyValue === 'true' ||
      privacyValue === TRUE ||
      privacyValue === String(TRUE)
    )
  }

  isTermsAccepted(termsValue) {
    return (
      termsValue === true ||
      termsValue === 'true' ||
      termsValue === TRUE ||
      termsValue === String(TRUE)
    )
  }

  isValidAmount(amount) {
    if (!amount) return false

    const numAmount =
      typeof amount === 'string'
        ? parseFloat(amount.replace('custom-number-', ''))
        : amount

    return !isNaN(numAmount) && numAmount > 0
  }

  validatePaymentRequest(formData, { showToast = true } = {}) {
    const errors = []

    if (!this.isPrivacyAccepted(formData[DONATION_PRIVACY])) {
      errors.push(
        new ValidationError(
          DONATION_PRIVACY,
          'REQUIRED',
          "Devi accettare l'informativa sul trattamento dei dati personali"
        )
      )
    }

    if (!this.isValidAmount(formData[DONATION_AMOUNT])) {
      errors.push(
        new ValidationError(DONATION_AMOUNT, 'INVALID', 'Importo non valido')
      )
    }

    if (showToast && errors.length > 0) {
      toast.warn(errors[0].message, {
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
    }

    return {
      isValid: errors.length === 0,
      errors,
      firstError: errors[0] || null,
    }
  }

  validateRecurrentPayment(formData) {
    const errors = []

    const baseValidation = this.validatePaymentRequest(formData, {
      showToast: false,
    })
    errors.push(...baseValidation.errors)

    if (errors.length > 0) {
      toast.warn(errors[0].message, {
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
    }

    return {
      isValid: errors.length === 0,
      errors,
      firstError: errors[0] || null,
    }
  }
}

const paymentValidator = new PaymentValidator()
export default paymentValidator
